import { dynamic } from '#/utils/dynamic';

export const DynamicSlideshow = dynamic(
  () =>
    import('./Slideshow').then((m) => ({
      default: m.Slideshow,
    })),
  { strategy: 'always' },
);
